module.exports = __webpack_public_path__ + "img/splitFileNum3.533040c9.svg";